var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F8BD25"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.5H7.5C7.0875 19.5 6.73438 19.3531 6.44063 19.0594C6.14688 18.7656 6 18.4125 6 18V6C6 5.5875 6.14688 5.23438 6.44063 4.94063C6.73438 4.64688 7.0875 4.5 7.5 4.5H13.5L18 9V18C18 18.4125 17.8531 18.7656 17.5594 19.0594C17.2656 19.3531 16.9125 19.5 16.5 19.5ZM12.75 9.75V6H7.5V18H16.5V9.75H12.75ZM7.5 9.75V6V18V9.75ZM9 12.75H15V11.25H9V12.75ZM9 15H15V13.5H9V15ZM9 17.25H12.75V15.75H9V17.25Z",
    fill: "#705000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.d0883bf49eda33ec15ac84e64f189e85.svg";
export { ForwardRef as ReactComponent };